import axios from 'axios';
const BASE_URL = window.__UMS_THEME__?.serverEndpoint || process.env.REACT_APP_SERVER_ENDPOINT;

export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate2 = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    withCredentials: true
});